module.exports = __webpack_public_path__ + "static/img/rank.4199cb98.png";